import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
import { MAX_PART_LINES_PER_CREATE, MAX_PART_LINES_PER_CREATE_MESSAGE, PURCHASE_ORDER_CONSTRAINTS, } from './constraints.js';
import { parsePurchaseOrderQuantity, PURCHASE_ORDER_QUANTITY_MESSAGE } from './item-quantity.js';
import { parsePurchaseOrderUnitCost } from './item-unit-cost.js';
export const purchaseOrderPartLineFormFieldsSchema = z.object({
    partId: optionalUuidString('Invalid part selection.'),
    quantity: z.string().trim(),
    vendorId: optionalUuidString(`Invalid ${PURCHASE_ORDER_CONSTRAINTS.vendorOverride.label.toLowerCase()} selection.`),
    unitCost: z.string().trim(),
    selected: z.boolean().optional(),
});
export const purchaseOrderCreateFormFieldsSchema = z.object({
    locationGroupId: optionalUuidString(`Invalid ${PURCHASE_ORDER_CONSTRAINTS.locationGroup.label.toLowerCase()} selection.`),
    brandId: optionalUuidString('Invalid brand selection.'),
    fobPointId: optionalUuidString('Invalid FOB point selection.'),
    expectedDeliveryDate: z.string().trim(),
    vendorId: optionalUuidString(`Invalid ${PURCHASE_ORDER_CONSTRAINTS.vendor.label.toLowerCase()} selection.`),
    paymentTermsId: optionalUuidString('Invalid payment terms selection.'),
    note: z
        .string()
        .trim()
        .max(PURCHASE_ORDER_CONSTRAINTS.note.maxLength, `${PURCHASE_ORDER_CONSTRAINTS.note.label} must be ${PURCHASE_ORDER_CONSTRAINTS.note.maxLength} characters or fewer.`),
    lines: z
        .array(purchaseOrderPartLineFormFieldsSchema)
        .max(MAX_PART_LINES_PER_CREATE, MAX_PART_LINES_PER_CREATE_MESSAGE),
});
export const purchaseOrderCreateFormSchema = purchaseOrderCreateFormFieldsSchema.superRefine((values, context) => {
    if (!values.locationGroupId) {
        context.addIssue({
            code: 'custom',
            message: `${PURCHASE_ORDER_CONSTRAINTS.locationGroup.label} is required.`,
            path: ['locationGroupId'],
        });
    }
    if (!values.brandId) {
        context.addIssue({
            code: 'custom',
            message: `${PURCHASE_ORDER_CONSTRAINTS.brand.label} is required.`,
            path: ['brandId'],
        });
    }
    if (!values.vendorId) {
        context.addIssue({
            code: 'custom',
            message: `${PURCHASE_ORDER_CONSTRAINTS.vendor.label} is required.`,
            path: ['vendorId'],
        });
    }
    if (!values.paymentTermsId) {
        context.addIssue({
            code: 'custom',
            message: `${PURCHASE_ORDER_CONSTRAINTS.paymentTerms.label} is required.`,
            path: ['paymentTermsId'],
        });
    }
    const hasSelectedLines = values.lines.some((line) => line.selected !== false && line.partId);
    if (!hasSelectedLines) {
        context.addIssue({
            code: 'custom',
            message: 'Select at least one part to order.',
            path: ['lines'],
        });
        return;
    }
    values.lines.forEach((line, lineIndex) => {
        if (line.selected === false || !line.partId) {
            return;
        }
        const quantity = parsePurchaseOrderQuantity(line.quantity);
        if (quantity === undefined) {
            context.addIssue({
                code: 'custom',
                message: PURCHASE_ORDER_QUANTITY_MESSAGE,
                path: ['lines', lineIndex, 'quantity'],
            });
        }
        const unitCostResult = parsePurchaseOrderUnitCost(line.unitCost, PURCHASE_ORDER_CONSTRAINTS.unitCost.label);
        if (typeof unitCostResult === 'string') {
            context.addIssue({
                code: 'custom',
                message: unitCostResult,
                path: ['lines', lineIndex, 'unitCost'],
            });
        }
    });
});
//# sourceMappingURL=create-form.js.map